import eventbus from '@/utils/eventbus';
import state from '@/state';

export default function(merchantCustomerId, defaultTab) {
  if (!merchantCustomerId) {
    merchantCustomerId = state.profile?.id;
    if (!merchantCustomerId) {
      console.error('No merchantCustomerId given and no profile loaded');
      return;
    }
  }

  let existingCustomerId = null;
  function onCardExists(customerId) {
    existingCustomerId = customerId;
  }

  eventbus.once('customerCardExists', onCardExists);
  eventbus.emit('setCustomerCardTab', defaultTab); // We have to emit this even when defaultTab is not set, this is because we expect it to call us back
  eventbus.off('customerCardExists', onCardExists);

  if (existingCustomerId && existingCustomerId === merchantCustomerId) {
    return;
  }

  eventbus.emit('openPopupProfileCard', merchantCustomerId, defaultTab);
}
